// src/components/Footer.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaInstagram,
} from "react-icons/fa";
import "./Footer.css";

import logo from "../assets/logo.png"; // replace with your logo path
import g1 from "../assets/gallery-1.jpg";
import g2 from "../assets/gallery-2.jpg";
import g3 from "../assets/gallery-3.jpg";
import g4 from "../assets/gallery-4.jpeg";

const Footer = () => {
  return (
    <footer className="footer-section">
      <Container>
        <Row className="py-5 text-white">
          {/* Left - Logo & Info */}
          <Col md={3} sm={12} className="mb-4">
            <img src={logo} alt="Gramen Logo" className="footer-logo" />
           <p>
  Effective project management ensures seamless coordination, on-time delivery, 
  and optimized resource utilization. From strategic planning to execution, 
  we help organizations streamline workflows, mitigate risks, and achieve 
  business goals with measurable results.
</p>
          
          </Col>

          {/* Quick Links */}
          <Col md={3} sm={6} className="mb-4">
            <h5 className="fw-bold mb-3">Quick Links</h5>
            <ul className="footer-links">
             <li><Link to="/about">About Us</Link></li>
        <li><Link to="/team">Our Team</Link></li>
        <li><Link to="/service">Our Services</Link></li>
        <li><Link to="/Blog">Latest Blog</Link></li>
        <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </Col>

          {/* Our Services */}
          <Col md={3} sm={6} className="mb-4">
            <h5 className="fw-bold mb-3">Our Services</h5>
            <ul className="footer-links">
              <li><Link to="/service">Government &amp; Public Sector</Link></li>
  <li><Link to="/service">Healthcare</Link></li>
  <li><Link to="/service">Telecommunications</Link></li>
  <li><Link to="/service">Retail &amp; E-Commerce</Link></li>
  <li><Link to="/service">Education &amp; Training</Link></li>
  <li><Link to="/service">Trade &amp; Supply Chain</Link></li>
            </ul>
          </Col>

          {/* Our Gallery */}
        <Col md={3} sm={12} className="mb-4">
  <h5 className="fw-bold mb-3">Our Gallery</h5>
  <div className="footer-gallery">
    <div className="gallery-grid">
      <img src={g1} alt="Gallery1" />
      <img src={g2} alt="Gallery2" />
      <img src={g3} alt="Gallery3" />
      <img src={g4} alt="Gallery4" />
    </div>
  </div>
</Col>

        </Row>
      </Container>

      {/* Bottom bar */}
      <div className="footer-bottom py-3">
        <Container className="d-flex justify-content-between align-items-center flex-wrap text-white">
        
 <p className="mb-0">
  © All Copyright 2025 by Strat Edge |{" "}
  <a
    href="https://www.pawartechnologyservices.com/" // 👉 replace with actual PTS site link
    target="_blank"
    rel="noopener noreferrer"
    style={{ textDecoration: "none", color: "#ffffff", fontWeight: "500" }}
  >
    Design by PTS
  </a>
</p>



          <div className="social-links">
            <a href="https://www.facebook.com/profile.php?id=61581231150639&mibextid=wwXIfr&rdid=8W2mq3HvgHGv9isH&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BCMNEdbV3%2F%3Fmibextid%3DwwXIfr#"><FaFacebookF /></a>
            <a href="https://x.com/stratedgepm?s=11&t=grt9FJqqZHF7j9EPMUViXg"><FaTwitter /></a>
            <a href="https://www.linkedin.com/company/strat-edge-project-management-services/"><FaLinkedinIn /></a>
            <a href="https://www.instagram.com/stratedge_projectmanagement?igsh=MXU1bGRuaDVjZnVjMQ%3D%3D&utm_source=qr"> <FaInstagram /></a>
          </div>
          <div className="footer-policies">
            <a href="/terms">Terms & Condition</a>
            <a href="privacy">Privacy Policy</a>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
